import { MESES } from "../constants";

export const eliminarNumeracion = (text) => {
  return text.indexOf(".") !== -1 ? text.split(".")[1].trim() : text;
};

export const formatCuil = (cuil) =>
  `${cuil.slice(0, 2)}-${cuil.slice(2, cuil.length - 1)}-${cuil.slice(-1)}`;

export const getDateFormated = (date) =>
  `${date.getDate()} de ${MESES[date.getMonth()]} del ${date.getFullYear()}`;

export const cookieValue = (name) => {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name));
  if (!cookie) return "";

  return cookie.split("=")[1] || "";
};

export const getParsedCookie = (name) => {
  const cookie = cookieValue(name);
  if (!cookie) return null;

  try {
    return JSON.parse(cookie);
  } catch (error) {
    console.error(`Error al parsear la cookie ${name}:`, error);
    return null;
  }
};

export const isNative = () => {
  return window.ReactNativeWebView !== null;
};

export const isNative2 = async (retries = 5, interval = 400) => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isWebView =
    isIOS &&
    !window.navigator.standalone &&
    typeof window.webkit !== "undefined";
  if (
    typeof window.ReactNativeWebView !== "undefined" &&
    window.ReactNativeWebView !== null
  ) {
    return true;
  }

  for (let i = 0; i < retries; i++) {
    if (isWebView) {
      return true;
    }

    if (
      typeof window.ReactNativeWebView !== "undefined" &&
      window.ReactNativeWebView !== null
    ) {
      return true;
    }

    await new Promise((resolve) => setTimeout(resolve, interval));
  }
  return false;
};

export const getSO = async (retries = 5, interval = 400) => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (isIOS) return "ios";

  for (let i = 0; i < retries; i++) {
    if (
      typeof window.ReactNativeWebView !== "undefined" &&
      window.ReactNativeWebView !== null
    ) {
      return "android";
    }

    await new Promise((resolve) => setTimeout(resolve, interval));
  }
  return "web";
};
